module.exports = __webpack_public_path__ + "img/independent-auditor.581a8d2d.svg";